// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__10srO","rootCenter":"LoadMoreObserver_rootCenter__loBr6","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__9fwju"};